import { isNullOrWhitespace } from '../utility';

import { mfsError } from '../errors';

/** The configuration for the Mfs Host */
export type MfsHostConfig = {
  /** The optional schema version for the items stored in Mfs by the current host. Default is 0. */
  readonly dataModelVersion?: number;
};

/** Represents the unique attributes of a MetaOS app or node-host, that will be interacting with the store */
export class MfsHost {
  /** The host id. */
  readonly id: string;

  /**
   * Optional, monotonically increasing sequence number. Apps, if they choose to, might prefer to increment this when
   * the app's MFS schema changes in a backward incompatible way.
   */
  readonly dataModelVersion?: string;

  /** Session Id set by the client. If its not set by the client, MFS sets it for the client. Used for telemetry purposes */
  readonly sessionId?: string;

  /**
   * Creates a new instance of `MfsHost`.
   *
   * @example
   *   ```ts
   *       // create and read item from the current app.
   *       const item = mfs.createItem({ a: 'a', label: 'x' });
   *       {
   *          a: 'a';
   *       }
   *   ```;
   *
   * @param id The unique identifier of the app (or node-host). For MetaOS apps connecting with OdspClient, MFS uses the
   *   AAD-App Id.
   * @param [config] The optional {@link MfsHostConfig}. Specified if data model versioning is needed.
   */
  constructor(id: string, config?: MfsHostConfig) {
    MfsHost.throwIfInvalidId(id);

    this.id = id.trim();
    this.dataModelVersion =
      config?.dataModelVersion === undefined ? undefined : 'v' + config.dataModelVersion.toString();
  }

  /** @private */
  static throwIfInvalidId(id: string): void {
    if (isNullOrWhitespace(id)) {
      throw mfsError.invalidAppId();
    }
  }
}
